module.exports = __webpack_public_path__ + "static/cctx-min-0b6d2d208ecfa3bc72fd93704ec2ca5f.jpg";